export default __webpack_public_path__ + "static/media/global-icon-four.18c759c8.svg";